import lotteries from '@data/lotteries';
export default (id) => {
  if (!id) { return; }
  return lotteries.find((a) => a.id == id);
};
